var API_URL = process.env.REACT_APP_API_URL || process.env.NEXT_PUBLIC_API_URL || process.env.API_URL || 'https://api.picsart.com';
var SSO_API_URL = process.env.REACT_APP_WEB_SSO_API_URL || process.env.NEXT_PUBLIC_SSO_API_URL || process.env.SSO_API_URL || process.env.REACT_APP_SSO_API_URL || 'https://sso.picsart.com';
var RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY || process.env.NEXT_PUBLIC_RECAPTCHA_PUBLIC_KEY || process.env.RECAPTCHA_PUBLIC_KEY || '';
var GOOGLE_CLIENT_ID = process.env.REACT_APP_PUBLIC_GOOGLE_CLIENT_ID || '272170329423-eqnd70u7g34lk56aj4pqahg57r6u659b.apps.googleusercontent.com';
var FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID || '108569252539536';
var USER_KEY_DISABLED = !!(process.env.REACT_APP_USER_KEY_DISABLED || process.env.NEXT_PUBLIC_USER_KEY_DISABLED || process.env.USER_KEY_DISABLED);
var USER_KEY_HEADER_DISABLED = !!(process.env.REACT_APP_USER_KEY_HEADER_DISABLED || process.env.NEXT_PUBLIC_USER_KEY_HEADER_DISABLED || process.env.USER_KEY_HEADER_DISABLED);
var PICSART_HOST_URL = process.env.REACT_APP_PICSART_HOST_URL || process.env.NEXT_PUBLIC_PICSART_HOST_URL || process.env.PICSART_HOST_URL || '';
var forcedLogin = true;
var RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY || process.env.NEXT_PUBLIC_RECAPTCHA_PUBLIC_KEY || '6LdM2s8cAAAAAN7jqVXAqWdDlQ3Qca88ke3xdtpR';
var RECAPTCHA_SCRIPT_SRC = "https://www.google.com/recaptcha/enterprise.js?render=".concat(RECAPTCHA_SITE_KEY);
var CURRENT_LANGUAGE_COOKIE_NAME = 'currentLanguage';
var DEFAULT_MAX_AGE = 30 * 24 * 3600000;
var USER_KEY_COOKIE_NAME = 'user_key';
var USER_EMAIL_COOKIE_NAME = 'user_email';
var IS_SUBSCRIBED_COOKIE_NAME = 'is_subscribed';
var GT_USER_ID_COOKIE_NAME = 'gtm_user_id';
var G_STATE_ONE_TAP = 'g_state';
var SOCIAL_REQUEST_HEADER_TOKEN = 'hI3KTwebV5yr2Gj';
var AUTOMATION_USERAGENT_MOCK = 'koreanUserAgent';
var GEO_ZONE_KEY = 'geo_zone';
var ANALITICS_SOURCES = {
  growth: 'growth',
  photoEditor: 'photo-editor',
  videoEditor: 'video-editor',
  monetization: 'monetization'
};
var allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
var KeyBoardKeys = /*#__PURE__*/function (KeyBoardKeys) {
  KeyBoardKeys["Enter"] = "Enter";
  KeyBoardKeys["Spacebar"] = "Spacebar";
  KeyBoardKeys["EmptySpacebar"] = " ";
  return KeyBoardKeys;
}({});
var KeyboardKeyCodes = /*#__PURE__*/function (KeyboardKeyCodes) {
  KeyboardKeyCodes[KeyboardKeyCodes["Enter"] = 13] = "Enter";
  KeyboardKeyCodes[KeyboardKeyCodes["Spacebar"] = 32] = "Spacebar";
  return KeyboardKeyCodes;
}({});
var TOP_NAVIGATION_EXPERIMENT_ID = 'LBI_JENfSg-lIT_-WSyOJw';
var TOP_NAVIGATION_EXPERIMENT_COOKIE_NAME = 'top-navigation-experiment-variant';
var LANGUAGE_HEADER_KEY = 'language-code';
var FACEBOOK = 'facebook';
var GOOGLE = 'google';
var EMAIL = 'email';
var APPLE = 'apple';
var ICONS = /*#__PURE__*/function (ICONS) {
  ICONS["eyeOpenGen"] = "eye-open-gen";
  ICONS["eyeClosedGen"] = "eye-closed-gen";
  return ICONS;
}({});
var signUp = 'sign_up';
var signIn = 'sign_in';
var POPUP_OPEN = 'popup_open';
var REGISTRATION_OPEN = 'registration_open';
var MOBILE_DEEPLINK_BASE = "".concat(API_URL, "/v1/deeplink/content");
var WINDOW_MARKET_DEEPLINK = 'https://apps.microsoft.com/windows/en-us/app/109e8ce6-65e9-4f52-b1b6-3942a9851cd8';
var EDITOR_CHOOSER_DEEPLINK = 'picsart://create_flow';
var ResponseStatus = /*#__PURE__*/function (ResponseStatus) {
  ResponseStatus["success"] = "success";
  ResponseStatus["error"] = "error";
  return ResponseStatus;
}({});
var RequestHeaders = /*#__PURE__*/function (RequestHeaders) {
  RequestHeaders["xApiKey"] = "x-api-key";
  RequestHeaders["gRecaptchaToken"] = "g-recaptcha-token";
  RequestHeaders["token"] = "token";
  RequestHeaders["platform"] = "platform";
  return RequestHeaders;
}({});
var UserTypes = /*#__PURE__*/function (UserTypes) {
  UserTypes["canceled"] = "SUBSCRIPTION_CANCELED";
  return UserTypes;
}({});
var USER_STORAGE_SESSION_STORAGE_KEY = 'userStorage';
var defaultErrorMessage = 'Something went wrong, please try again.';
var ERRORS_REASONS = /*#__PURE__*/function (ERRORS_REASONS) {
  ERRORS_REASONS["Incorrect"] = "username_or_password_incorrect";
  return ERRORS_REASONS;
}({});

// Slider
var CarouselDirection = /*#__PURE__*/function (CarouselDirection) {
  CarouselDirection["LEFT"] = "left";
  CarouselDirection["RIGHT"] = "right";
  return CarouselDirection;
}({});
var CAROUSEL_SCROLL_VALUE = 188;
var SliderEventTypes = /*#__PURE__*/function (SliderEventTypes) {
  SliderEventTypes["click"] = "click";
  SliderEventTypes["wheel"] = "wheel";
  SliderEventTypes["touchMove"] = "touchMove";
  return SliderEventTypes;
}({});

export { ANALITICS_SOURCES, API_URL, APPLE, AUTOMATION_USERAGENT_MOCK, CAROUSEL_SCROLL_VALUE, CURRENT_LANGUAGE_COOKIE_NAME, CarouselDirection, DEFAULT_MAX_AGE, EDITOR_CHOOSER_DEEPLINK, EMAIL, ERRORS_REASONS, FACEBOOK, FACEBOOK_APP_ID, GEO_ZONE_KEY, GOOGLE, GOOGLE_CLIENT_ID, GT_USER_ID_COOKIE_NAME, G_STATE_ONE_TAP, ICONS, IS_SUBSCRIBED_COOKIE_NAME, KeyBoardKeys, KeyboardKeyCodes, LANGUAGE_HEADER_KEY, MOBILE_DEEPLINK_BASE, PICSART_HOST_URL, POPUP_OPEN, RECAPTCHA_KEY, RECAPTCHA_SCRIPT_SRC, RECAPTCHA_SITE_KEY, REGISTRATION_OPEN, RequestHeaders, ResponseStatus, SOCIAL_REQUEST_HEADER_TOKEN, SSO_API_URL, SliderEventTypes, TOP_NAVIGATION_EXPERIMENT_COOKIE_NAME, TOP_NAVIGATION_EXPERIMENT_ID, USER_EMAIL_COOKIE_NAME, USER_KEY_COOKIE_NAME, USER_KEY_DISABLED, USER_KEY_HEADER_DISABLED, USER_STORAGE_SESSION_STORAGE_KEY, UserTypes, WINDOW_MARKET_DEEPLINK, allowedTypes, defaultErrorMessage, forcedLogin, signIn, signUp };
//# sourceMappingURL=index.js.map
